module.exports = __webpack_public_path__ + "img/fa.dfd57d83.svg";